export function msToAgo(timestamp: number, language: string) {
    const now = Date.now()
    const ms = now - timestamp
    const days = Math.floor(ms / (24 * 60 * 60 * 1000))
    const daysms = ms % (24 * 60 * 60 * 1000)
    const hours = Math.floor(daysms / (60 * 60 * 1000))
    const hoursms = ms % (60 * 60 * 1000)
    const minutes = Math.floor(hoursms / (60 * 1000))
    const minutesms = ms % (60 * 1000)
    const sec = Math.floor(minutesms / 1000)

    const rtf1 = new Intl.RelativeTimeFormat(language, { style: 'narrow' })
    const timeAgo =
        rtf1.format(-days, 'day') ||
        rtf1.format(-hours, 'hours') ||
        rtf1.format(-minutes, 'minutes') ||
        rtf1.format(-sec, 'seconds')

    return timeAgo
}

export function msToHour(timestamp: number) {
    return new Date(timestamp).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
    })
}

export function msToExactDate(timestamp: number, language: string) {
    return new Date(timestamp).toLocaleDateString(language, {
        year: 'numeric',
        month: 'long',
        day: '2-digit',
    })
}
